import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup/dist/yup';

export interface UserInfoT {
  email: string;
  firstName: string;
  lastName: string;
  photo?: string;
}

export const useUserInfoForm = ({
  requiredError,
}: {
  requiredError: string;
}) => {
  const formUserValues = {
    email: '',
    firstName: '',
    lastName: '',
    photo: '',
  };

  const UserSchema = yup
    .object({
      firstName: yup.string().required(requiredError),
      lastName: yup.string().required(requiredError),
      email: yup.string().email(requiredError!).required(requiredError),
      photo: yup.string(),
    })
    .required();

  const {
    watch,
    getValues,
    setValue,
    register,
    handleSubmit,
    clearErrors,
    trigger,
    formState: { errors },
  } = useForm<UserInfoT>({
    resolver: yupResolver(UserSchema),
    defaultValues: formUserValues,
  });

  return {
    watch,
    getValues,
    setValue,
    errors,
    register,
    handleSubmit,
    clearErrors,
    trigger,
  };
};
